import {Routes} from '@angular/router';
import {StartPageComponent} from './entities/startpage/startpage.component';
import {UserListComponent} from './entities/userlist/userlist.component';
import {SkillsComponent} from './entities/skills/skills.component';
import {ConsultantComponent} from './entities/consultant/consultant.component';
import {AdmindashComponent} from './entities/admindash/admindash.component';
import {ImprintComponent} from './entities/imprint/imprint.component';
import {CataloguesComponent} from './entities/catalogues/catalogues.component';
import {
  ReportCardContributionComponent
} from './entities/report-card/report-card-contribution/report-card-contribution.component';
import {EditCatalogueComponent} from './entities/catalogues/edit-catalogue/edit-catalogue.component';
import {AuthGuard} from './auth.guard';
import {ReportCardComponent} from './entities/report-card/make-report-card/report-card.component';
import {NoRoleFoundComponent} from './entities/no-role-found/no-role-found.component';
import {TextOnlyComponent} from './entities/text-only/text-only.component';
import {LandingPageComponent} from './overview/landing-page.component/landing-page.component';
import {VideosComponent} from './entities/videos/videos.component';
import {RequestsComponent} from './entities/requests/requests.component';
import {BenchComponent} from './entities/bench/bench.component';
import {AiProfileMatchingComponent} from './entities/ai-profile-matching/ai-profile-matching.component';
import {WartungComponent} from './entities/wartung/wartung.component';
import {MaintenanceAdminComponent} from './entities/maintenance-admin/maintenance-admin.component';
import {CvImportWizardComponent} from './entities/cv-import/cv-import-wizard.component';
import {BenchOverviewComponent} from './entities/bench-overview/bench-overview.component';
import {BenchDetailComponent} from './entities/bench-overview/bench-detail/bench-detail.component';
import {MeetingModeComponent} from './entities/bench-overview/meeting-mode/meeting-mode.component';
import {SalesViewComponent} from './entities/bench-overview/sales-view/sales-view.component';
import {TogetherComponent} from './entities/together/together.component';

export const routes: Routes = [
  {
    path: 'together',
    component: TogetherComponent,
    canActivate: [AuthGuard],
    data: {roles: ['Admin', 'Sale', 'User', 'Office'], breadcrumb: 'nav.together'},
  },
  {
    path: 'profile/me',
    component: ConsultantComponent,
    canActivate: [AuthGuard],
    data: {roles: ['User'], breadcrumb: 'nav.profile'},
  },
  {
    path: 'profile/:id',
    component: ConsultantComponent,
    canActivate: [AuthGuard],
    data: {roles: ['Office', 'Admin', 'Sale'], breadcrumb: 'nav.profile'},
  },
  {
    path: 'katalog/:id',
    component: EditCatalogueComponent,
    canActivate: [AuthGuard],
    data: {roles: ['Sale', 'Admin', 'Office'], breadcrumb: 'nav.catalogue'},
  },
  {
    path: '',
    component: LandingPageComponent,
  },
  {
    path: 'home',
    component: StartPageComponent,
    canActivate: [AuthGuard],
    data: {roles: ['Admin', 'Sale', 'User', 'Office']},
  },
  {
    path: 'katalog',
    component: CataloguesComponent,
    canActivate: [AuthGuard],
    data: {roles: ['Sale', 'Admin', 'Office'], breadcrumb: 'nav.catalogues'},
  },
  {
    path: 'skills',
    component: SkillsComponent,
    canActivate: [AuthGuard],
    data: {roles: ['Admin', 'Office'], breadcrumb: 'nav.skills'},
  },
  {
    path: 'berater-list',
    component: UserListComponent,
    canActivate: [AuthGuard],
    data: {roles: ['Office', 'Admin', 'Sale'], breadcrumb: 'nav.consultants'},
  },
  {
    path: 'report',
    component: ReportCardContributionComponent,
    canActivate: [AuthGuard],
    data: {roles: ['Office', 'Admin'], breadcrumb: 'nav.report'},
  },
  {
    path: 'administration',
    component: AdmindashComponent,
    canActivate: [AuthGuard],
    data: {roles: ['Admin', 'Office'], breadcrumb: 'nav.adminDash'},
  },
  {
    path: 'admin-dash',
    redirectTo: 'administration',
    pathMatch: 'full',
  },
  {
    path: 'impressum',
    component: ImprintComponent,
    data: {breadcrumb: 'nav.imprint'},
  },
  {
    path: 'skill/:id',
    redirectTo: 'skills',
  },
  {
    path: 'zeugnis/:id',
    component: ReportCardComponent,
    canActivate: [AuthGuard],
    data: {roles: ['Office', 'Admin'], breadcrumb: 'nav.certificate'},
  },
  {
    path: 'bench',
    component: BenchComponent,
    canActivate: [AuthGuard],
    data: {roles: ['Sale', 'Admin', 'Office'], breadcrumb: 'nav.bench'},
  },
  {
    path: 'berater-abfrage',
    component: BenchOverviewComponent,
    canActivate: [AuthGuard],
    data: {roles: ['Sale', 'Admin', 'Office'], breadcrumb: 'nav.benchOverview'},
  },
  // Order is load-bearing: the literal 'meeting' route must precede 'berater-abfrage/:id',
  // otherwise ':id' would swallow it and route to the detail view.
  {
    path: 'berater-abfrage/meeting',
    component: MeetingModeComponent,
    canActivate: [AuthGuard],
    data: {roles: ['Sale', 'Admin', 'Office'], breadcrumb: 'nav.benchMeeting'},
  },
  {
    path: 'berater-abfrage/sales',
    component: SalesViewComponent,
    canActivate: [AuthGuard],
    data: {roles: ['Sale', 'Admin', 'Office'], breadcrumb: 'nav.benchSalesView'},
  },
  {
    path: 'berater-abfrage/:id',
    component: BenchDetailComponent,
    canActivate: [AuthGuard],
    data: {roles: ['Sale', 'Admin', 'Office'], breadcrumb: 'nav.benchDetail'},
  },
  {
    path: 'no-role',
    component: NoRoleFoundComponent,
  },
  {
    path: 'berater/:id/text',
    component: TextOnlyComponent,
    canActivate: [AuthGuard],
    data: {roles: ['Office', 'Sale', 'Admin'], breadcrumb: 'nav.textOnly'},
  },
  {
    path: 'auth/users/reset/finish',
    component: LandingPageComponent,
  },
  {
    path: 'tutorials',
    component: VideosComponent,
    data: {breadcrumb: 'nav.tutorials'},
  },
  {
    path: 'requests',
    component: RequestsComponent,
    canActivate: [AuthGuard],
    data: {roles: ['Admin', 'Office'], breadcrumb: 'nav.requests'},
  },
  {
    path: 'aiProfileMatching/:consultantId',
    component: AiProfileMatchingComponent,
    canActivate: [AuthGuard],
    data: {roles: ['Admin', 'Office'], breadcrumb: 'nav.aiProfileMatching'},
  },
  {
    path: 'cv-import/:consultantId',
    component: CvImportWizardComponent,
    canActivate: [AuthGuard],
    data: {roles: ['Admin', 'Office', 'Sale'], breadcrumb: 'nav.cvImport'},
  },
  {
    path: 'wartung',
    component: WartungComponent,
    data: {breadcrumb: 'nav.maintenance'},
  },
  {
    path: 'admin/wartung',
    component: MaintenanceAdminComponent,
    canActivate: [AuthGuard],
    data: {roles: ['Admin'], breadcrumb: 'nav.maintenance'},
  },
];
